export default "__VITE_ASSET__c662ce46__"